var rscBridge
(function (w, d) {
  if (!window.rscBridge) {
    window.rscBridge = {}
  }
  var isJSBridge = false
  function connectJSBridge (callback) {
    if (w.JSBridge) {
      isJSBridge = true
      callback(w.JSBridge)
    } else {
      d.addEventListener('JSBridgeReady', function () {
        isJSBridge = true
        callback(w.JSBridge)
      }, false)
    }
  }
  rscBridge = {
    version: '1.0',
    isJSBridge: function () {
      return isJSBridge
    },
    callback: function (e) {
    },
    init: function () {
      var _self = this
      connectJSBridge(function (bridge) {
        bridge.init(function (message, responseCallback) {
          var data = { 'Javascript Responds': 'Wee!' }
          bridge.callEventCallback(responseCallback, data, message)
        })
        var apiList = {
          loadDetail: function (e) { // 路演详情页面
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeDetail', e.data)
              return true
            } else {
              return false
            }
          },
          loadTalent: function (e) { // 团队人员
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeTalent', e.data)
              return true
            } else {
              return false
            }
          },
          login: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeLogin')
              return true
            } else {
              return false
            }
          },
          register: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeRegister')
              return true
            } else {
              return false
            }
          },
          getToken: function (e) {
            if (isJSBridge) {
              return w.JSBridge.callAPI('RSCJSAPI.NativeGetTokenSync')
            } else {
              return ''
            }
          },
          /**
                     * App分享页面
                     * @param e
                     * @returns {*}
                     */
          share: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeShare', e.data)
              return true
            } else {
              return false
            }
          },
          consoleTitle: function (e) {
            if (isJSBridge) {
              return w.JSBridge.callAPI('RSCJSAPI.NativeConsoleTitle', e.data)
            } else {
              return false
            }
          },
          shortTitle: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeShortTitle', e.data)
              return true
            } else {
              return false
            }
          }, // 弹出第三方绑定的窗口
          binding: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeBinding')
              return true
            } else {
              return false
            }
          },
          updateSubscription: function (subscribe, oid) {
            if (isJSBridge) {
              var subFlag = subscribe ? 'yes' : 'no'
              w.JSBridge.callAPI('RSCJSAPI.UpdateSubscription', { 'subscribe': subscribe, 'subFlag': subFlag, 'mid': 123, 'oid': oid }, function (response) {
              })
              return true
            } else {
              return false
            }
          },
          Index: function (e) {
            if (isJSBridge) {
              return w.JSBridge.callAPI('RSCJSAPI.NativeIndex')
            } else {
              return ''
            }
          },
          booking: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeBooking', e.data)
              return true
            } else {
              return false
            }
          },
          authNative: function (e) { //调起名片识别
            if (isJSBridge) {
              JSBridge.callAPI("RSCJSAPI.NativeAuth", e.data);
              return true;
          } else {
              return false;
          }
         },
          closeWindow: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.closeWindow')
              return true
            } else {
              return false
            }
          },
          loadClaimstore: function (e) { // 跳到认领旗舰店
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeClaimstore', e.data)
              return true
            } else {
              return false
            }
          },
          loadRoadShowList: function (e) { // 工作台路演List
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeRoadShowList', e.data)
              return true
            } else {
              return false
            }
          },
          loadResource: function (e) { // 工作台资源管理
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeResource', e.data)
              return true
            } else {
              return false
            }
          },
          loadParticipants: function (e) { // 工作台参会的人
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeParticipants', e.data)
              return true
            } else {
              return false
            }
          },
          loadSubscribers: function (e) { // 工作台订阅用户列表
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeSubscribers', e.data)
              return true
            } else {
              return false
            }
          },
          loadFlagshipStore: function (e) { // 工作台旗舰店跳转
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeFlagshipStore', e.data)
              return true
            } else {
              return false
            }
          },
          // 用户信息跳转编辑
          loadEditUserInfo: function (e) {
            if (isJSBridge) {
              console.log('rscBridge.js参数eData--->', e.data)
              w.JSBridge.callAPI('RSCJSAPI.NativeEditUserInfo', e.data)
              return true
            } else {
              return false
            }
          },
          /**
           * 机构详情或待办跳转用户信息
           * @param e
           */
          toUserInfo: function (e) {
            if (isJSBridge) {
              console.log('跳转用户信息eData--->', e.data)
              w.JSBridge.callAPI('RSCJSAPI.NativeWorkbenchUserInfo', e.data)
              return true
            } else {
              return false
            }
          },
          deleteUserInfo: function (e) {
            if (isJSBridge) {
              console.log('isJSBridge--deleteUserInfo-->', isJSBridge)
              w.JSBridge.callAPI('RSCJSAPI.NativeDeleteId', e.data)
              return true
            } else {
              console.log('isJSBridge--deleteUserInfo--false-->')
              return false
            }
          },
          auditFreeUserInfo: function (e) {
            if (isJSBridge) {
              console.log('isJSBridge -- NativeauditFree>', isJSBridge)
              w.JSBridge.callAPI('RSCJSAPI.NativeAuditFree', e.data)
              return true
            } else {
              console.log('isJSBridge--deleteUserInfo--false-->')
              return false
            }
          },
          workBenchMsgRead: function (e) { // 是否有代办信息给app消息
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeWorkbenchMsgRead', e.data)
              return true
            } else {
              return false
            }
          },
          // 添至联系人刷新native层状态
          addContactsRefresh: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.UpdateContactInfo', e.data)
              return true
            } else {
              return false
            }
          },
          // 退出工作台方法
          exitWorkbench: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.exitWorkbench', e.data)
              return true
            } else {
              return false
            }
          },
          // 我要路演进入的方法
          wantRoadShow: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeIWantRoadShow', e.data)
              return true
            } else {
              return false
            }
          },
          // 我要路演进入的方法
          showRecommendGroup: function (e) {
            if (isJSBridge) {
              w.JSBridge.callAPI('RSCJSAPI.NativeShowRecommendGroup', e.data)
              return true
            } else {
              return false
            }
          },
          enableLongPress: function (e) { //参数名:enable值: true, false 长按
            if (isJSBridge) {
              JSBridge.callAPI("RSCJSAPI.NativeEnableLongPress", e.data);
              return true;
          } else {
              return false;
          }
         },
        }
        _self.callback(apiList)
      })
      return true
    },
    share: function (e) {
      if (isJSBridge) {
        return w.JSBridge.callAPI('RSCJSAPI.NativeShare', e.data)
      } else {
        return false
      }
    },
    shortTitle: function (e) {
      if (isJSBridge) {
        w.JSBridge.callAPI('RSCJSAPI.NativeShortTitle', e.data)
        return true
      } else {
        return false
      }
    },
    consoleTitle: function (e) {
      if (isJSBridge) {
        return w.JSBridge.callAPI('RSCJSAPI.NativeConsoleTitle', e.data)
      } else {
        return false
      }
    }
  }
  rscBridge.init()
})(window, document)

export default rscBridge



// WEBPACK FOOTER //
// ./src/utils/rscBridge.js